import * as React from 'react'
import { styles } from './styles.css'

type Props = {
  question: string
  answer: string
}

export const FaqCard: React.FC<Props> = ({ question, answer }) => {
  return (
    <div className={styles.card}>
      <p className={styles.question}>Q：{question}</p>
      <p className={styles.answer}>A：{answer}</p>
    </div>
  )
}
